import { render } from "./SegundaViaBox.vue?vue&type=template&id=8f074eee"
import script from "./SegundaViaBox.vue?vue&type=script&lang=js"
export * from "./SegundaViaBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__